import * as React from 'react';

import { Modal, Button } from '@/components/ui';
import { useIsMobile } from '@/lib/hooks';

export interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmLogout: () => void;
  isLoading?: boolean;
}

const LogoutConfirmationModal = React.forwardRef<
  HTMLDivElement,
  LogoutConfirmationModalProps
>(({ isOpen, onClose, onConfirmLogout, isLoading = false }, ref) => {
  const isMobile = useIsMobile();

  return (
    <Modal
      ref={ref}
      isOpen={isOpen}
      onClose={onClose}
      title="Logout Confirmation"
      hideTitle={true}
      description="Are you sure, you want to sign out Student Dashboard?"
      hideDescription={true}
      className="p-6 max-w-sm md:max-w-md rounded-2xl mx-auto max-h-unset"
    >
      <div className="flex flex-col gap-4 items-center justify-center">
        {/* Title */}
        <div className="w-full">
          <h2 className="font-bold text-xl leading-7 text-center text-magical-moonlight-d3">
            Are you sure, you want to sign out Student Dashboard?
          </h2>
        </div>

        {/* Buttons */}
        <div className="flex items-center justify-center gap-4 w-full">
          <Button
            variant="outline"
            size={isMobile ? 'md' : 'lg'}
            onClick={onConfirmLogout}
            disabled={isLoading}
            isLoading={isLoading}
          >
            Yes, Sign Out
          </Button>

          <Button
            variant="contained"
            size={isMobile ? 'md' : 'lg'}
            onClick={onClose}
            disabled={isLoading}
          >
            No, I want to stay
          </Button>
        </div>
      </div>
    </Modal>
  );
});

LogoutConfirmationModal.displayName = 'LogoutConfirmationModal';

export { LogoutConfirmationModal };
export default LogoutConfirmationModal;
